import React from "react";

export function BodyTemplate({ title }) {
  return <div dangerouslySetInnerHTML={{ __html: title }} />;
}
